import { useState, useEffect } from "react";

const hourlyData = [
  { hour: "00", revenue: 1200, count: 8 },
  { hour: "01", revenue: 450, count: 3 },
  { hour: "02", revenue: 280, count: 2 },
  { hour: "03", revenue: 120, count: 1 },
  { hour: "04", revenue: 350, count: 2 },
  { hour: "05", revenue: 890, count: 6 },
  { hour: "06", revenue: 3560, count: 24 },
  { hour: "07", revenue: 8920, count: 58 },
  { hour: "08", revenue: 15680, count: 102 },
  { hour: "09", revenue: 22340, count: 145 },
  { hour: "10", revenue: 18560, count: 121 },
  { hour: "11", revenue: 16780, count: 109 },
  { hour: "12", revenue: 12340, count: 80 },
  { hour: "13", revenue: 9870, count: 64 },
  { hour: "14", revenue: 11230, count: 73 },
  { hour: "15", revenue: 13450, count: 87 },
  { hour: "16", revenue: 16780, count: 109 },
  { hour: "17", revenue: 21340, count: 139 },
  { hour: "18", revenue: 28900, count: 188 },
  { hour: "19", revenue: 24560, count: 160 },
  { hour: "20", revenue: 19870, count: 129 },
  { hour: "21", revenue: 14560, count: 95 },
  { hour: "22", revenue: 8900, count: 58 },
  { hour: "23", revenue: 4560, count: 30 },
];

export default function TodayRevenueChart() {
  const [liveData, setLiveData] = useState(hourlyData);
  const [total, setTotal] = useState(0);
  const [txCount, setTxCount] = useState(0);

  useEffect(() => {
    const t = liveData.reduce((s, d) => s + d.revenue, 0);
    const c = liveData.reduce((s, d) => s + d.count, 0);
    setTotal(t);
    setTxCount(c);
  }, [liveData]);

  useEffect(() => {
    const timer = setInterval(() => {
      setLiveData(prev => {
        const now = new Date();
        const h = now.getHours();
        return prev.map((d, i) => {
          if (i === h) {
            return { ...d, revenue: d.revenue + Math.floor(Math.random() * 200), count: d.count + Math.floor(Math.random() * 2) };
          }
          return d;
        });
      });
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const maxRevenue = Math.max(...liveData.map(d => d.revenue));
  const now = new Date().getHours();

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-line-chart-line text-[#E8531A] text-sm"></i>
          </div>
          <span className="text-sm font-semibold text-gray-800">今日营收动态</span>
          <span className="flex items-center gap-1 text-[10px] text-green-600 bg-green-50 px-1.5 py-0.5 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse inline-block"></span>
            实时更新
          </span>
        </div>
        <div className="text-right">
          <div className="text-base font-bold text-gray-900">¥{(total / 10000).toFixed(2)}<span className="text-xs text-gray-400 font-normal">万</span></div>
          <div className="text-[10px] text-gray-400">{txCount} 笔交易</div>
        </div>
      </div>

      {/* Bar chart */}
      <div className="flex items-end gap-0.5 h-20">
        {liveData.map((d, i) => {
          const pct = maxRevenue > 0 ? (d.revenue / maxRevenue) * 100 : 0;
          const isPast = i < now;
          const isCurrent = i === now;
          return (
            <div key={d.hour} className="flex-1 flex flex-col items-center gap-0.5 group relative">
              <div
                className={`w-full rounded-t transition-all duration-500 ${
                  isCurrent ? "bg-[#E8531A] animate-pulse" :
                  isPast ? "bg-[#E8531A]/60" : "bg-gray-100"
                }`}
                style={{ height: `${Math.max(pct, 2)}%` }}
              />
              {/* Tooltip */}
              <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-[9px] px-1.5 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                {d.hour}时: ¥{d.revenue.toLocaleString()}
              </div>
            </div>
          );
        })}
      </div>

      {/* X axis labels */}
      <div className="flex mt-1">
        {liveData.filter((_, i) => i % 4 === 0).map(d => (
          <div key={d.hour} className="flex-1 text-center text-[9px] text-gray-400">{d.hour}</div>
        ))}
      </div>

      {/* Stats row */}
      <div className="grid grid-cols-3 gap-2 mt-3 pt-3 border-t border-gray-100">
        <div className="text-center">
          <div className="text-xs font-bold text-gray-800">¥{(liveData.slice(0, now + 1).reduce((s, d) => s + d.revenue, 0) / 10000).toFixed(1)}万</div>
          <div className="text-[10px] text-gray-400">今日已收</div>
        </div>
        <div className="text-center">
          <div className="text-xs font-bold text-green-600">+12.5%</div>
          <div className="text-[10px] text-gray-400">同比昨日</div>
        </div>
        <div className="text-center">
          <div className="text-xs font-bold text-gray-800">{liveData.slice(0, now + 1).reduce((s, d) => s + d.count, 0)}</div>
          <div className="text-[10px] text-gray-400">交易笔数</div>
        </div>
      </div>
    </div>
  );
}
